import { memo } from "react";
import Svg, { Path, type SvgProps } from "react-native-svg";

const SvgBed = (props: SvgProps) => (
  <Svg fill="none" height={24} width={24} {...props}>
    <Path
      clipRule="evenodd"
      d="M1.092 6.641a4.363 4.363 0 0 1 4.363-4.363h13.09a4.363 4.363 0 0 1 4.363 4.363v3.272q0 .144-.018.283a2.18 2.18 0 0 1 1.108 1.9v7.566l.002.069v2.182a1.09 1.09 0 0 1-2.182 0v-1.091H2.182v1.09a1.09 1.09 0 0 1-2.182 0v-9.817a2.18 2.18 0 0 1 1.11-1.9 2 2 0 0 1-.018-.282zm4.363-2.182h13.09c1.205 0 2.182.977 2.182 2.182v3.272h-1.091v-1.09a2.18 2.18 0 0 0-2.182-2.182h-2.181a2.18 2.18 0 0 0-2.182 2.181v1.091H10.91v-1.09A2.18 2.18 0 0 0 8.727 6.64H6.545a2.18 2.18 0 0 0-2.181 2.181v1.091h-1.09V6.641c0-1.205.976-2.182 2.181-2.182m-3.273 7.636h19.634v6.545H2.182zm6.545-3.273H6.545v1.091h2.182zm6.546 0h2.181v1.091h-2.181z"
      fill={props.color}
      fillRule="evenodd"
    />
  </Svg>
);
const Memo = memo(SvgBed);
export default Memo;
